import React from "react";

interface Props {
  children: React.ReactNode;
}

const Container: React.FC<Props> = ({ children }) => {
  return (
    <div
      className="container pt-3"
      // style={{ marginTop: "80px" }}
    >
      {children}
    </div>
  );
};

export default Container;
